const fileSuffix = {
    audio: ['.mp3', '.wav', '.ape', '.flac', '.aac', '.wma', '.ra', '.mod', '.m4a'],
    video: ['.avi', '.mp4', '.m4v', '.vob', '.mts', '.264', '.asf', '.mkv', '.3gp', '.rmvb', '.mov', '.wmv', '.flv', '.mpg', '.f4v'],
    image: ['.jpg', '.jpeg', '.png', '.gif'],
    doc: ['.docx', '.doc', '.wps'],
    pdf: ['.pdf'],
    txt: ['.txt'],
    ppt: ['.pptx', '.ppt', '.dpt', '.dps'],
    zip: ['.btp', '.zip', '.iso'],
    xls: ['.wpt', '.xlsx', '.xls', '.ett', '.et'],
    dwg: ['.dwg'],
    apk: ['.apk']
}

const suffixMimeTypeMap = {}

for (let mt in fileSuffix) fileSuffix[mt].forEach(suffix => suffixMimeTypeMap[suffix] = mt)

export default {
    fileSuffix,
    suffixMimeTypeMap,
    fileTypeIcon: {
        audio: require('../assets/icon/mp3.png'),
        video: require('../assets/icon/raw.png'),
        image: require('../assets/icon/img.png'),
        doc: require('../assets/icon/word.png'),
        pdf: require('../assets/icon/pdf.png'),
        txt: require('../assets/icon/txt.png'),
        ppt: require('../assets/icon/ppt.png'),
        zip: require('../assets/icon/rar.png'),
        xls: require('../assets/icon/excel.png'),
        dwg: require('../assets/icon/indd.png'),
        apk: require('../assets/icon/sketch.png'),
        unknown: require('../assets/icon/unknown.png')
    },
    fileMimeType: {
        audio: ['audio/mp3', 'audio/wav', 'audio/ape', 'audio/flac', 'audio/aac', 'audio/wma', 'audio/ra', 'audio/mod', 'audio/m4a'],
        video: ['video/mp4', 'application/vnd.rn-realmedia-vbr', 'video/avi', 'video/mts', 'video/264', 'video/x-ms-asf', 'video/mkv', 'video/3gp', 'video/mov', 'video/x-ms-wmv', 'video/flv', 'video/mpg', 'video/f4v'],
        image: ['image/jpeg', 'image/gif', 'image/png'],
        doc: ['.docx', '.doc', '.wps'],
        pdf: ['.pdf'],
        txt: ['.txt'],
        ppt: ['.pptx', '.ppt', '.dpt', '.dps'],
        zip: ['.btp', '.zip', '.iso'],
        xls: ['.wpt', '.xlsx', '.xls', '.ett', '.et'],
        dwg: ['.dwg'],
        apk: ['application/vnd.android.package-archive']
    }
}
